import { Gradients } from "apparatus/gradients";
import { P, Pivot, R, Segments } from "apparatus/library/common";
import { Group, Path, Shape } from "paper";
export class DeskFan {
    render(appearance) {
        // Base
        const base = Shape.Rectangle(R(0, 0, 80, 15, Pivot.BOTTOM_CENTER), 5)
            .withFill("#bbbbbb");
        // Stand
        const stand = Shape.Rectangle(R(-10, -15, 20, 100, Pivot.BOTTOM_CENTER))
            .withGradientFill("right", Gradients.simple("#cccccc".color(), 10));
        // Motor housing
        const motor = Shape.Rectangle(R(0, 0, 60, 40, Pivot.CENTER_LEFT), 15)
            .withGradientFill("down", Gradients.simple("#cccccc".color(), 15));
        const axle = Shape.Rectangle(R(60, 0, 20, 10, Pivot.CENTER_LEFT), 2)
            .withFill("#888888");
        // Blade and Grille (Side view)
        // A thin ellipse or rectangle to represent the side profile of the fan cage
        const grille = Shape.Rectangle(R(0, 0, 40, 120, Pivot.CENTER), 20)
            .withFill("#ffffff20");
        const front = new Group([grille]);
        const blade = new Path(Segments([[0, -5], , [-12, -60]], [[6, -5], [18, -60]])).mirrorY()
            .withPositionDelta({ x: 66 })
            .close()
            .withGradientFill("down", Gradients.reflected(["#eeeeee", 0.0], ["#999999", 0.5]));
        // Add grille lines
        for (let i = -2; i <= 2; i++) {
            front.addChild(new Path(Segments([[-20, i * -16], , [0, i * -12]]))
                .mirrorX());
        }
        front.withPositionDelta({ x: 70 });
        // Combine Motor and front part into movable group
        const head = new Group([motor, blade, axle, front]);
        let windLines;
        if (appearance.showAirWaves) {
            windLines = new Group();
            for (let i = -1; i <= 1; i++) {
                const yOff = i * 25;
                windLines.addChild(new Path(Segments([[110, yOff], , [15, 10]], [[150, yOff + 10], [-15, -10], [15, 10]], [[190, yOff], [-15, -10],])));
            }
            head.addChild(windLines);
        }
        head.pivot = P(20, 0);
        head.position = P(-10, -115); // Position at the top of the stand
        head.rotation = appearance.tiltAngle;
        const graphic = new Group([base, stand, head]);
        graphic.scale(appearance.scale, P(0, 0));
        graphic.withStroke("default");
        if (windLines) {
            windLines.strokeColor = "#aaaaaa";
        }
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            pivot: P(0, 0),
            snapping: base.placeable(),
        };
    }
}
DeskFan.properties = {
    label: "Desk fan",
    flippable: true,
    defaultAppearance: {
        tiltAngle: 0,
        scale: 1.0,
        showAirWaves: false,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "tiltAngle", label: "Tilt angle",
            min: -15, max: 15, pipsStep: 15,
        },
        {
            spec: "slider", key: "scale", label: "Scale",
            min: 0.8, max: 1.2, step: 0.01, unit: "%",
        },
        {
            spec: "checkbox", key: "showAirWaves", label: "Show air waves",
        },
    ],
};
